import { removeItemsWithPrefix } from '@/utils/useLocalStorage'

const SIDEBAR_SECTION_STORAGE_PREFIX = 'sidebar_section_open:'

export const getSidebarSectionStorageKey = (title) => `${SIDEBAR_SECTION_STORAGE_PREFIX}${title}`

// Each login starts with every section back at its default (collapsed).
export const resetSidebarSectionState = () => removeItemsWithPrefix(SIDEBAR_SECTION_STORAGE_PREFIX)
